
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PartyBalanceDialog extends _Ext.EditorDialogBase<PartyBalanceRow> {
        protected getFormKey() { return PartyBalanceForm.formKey; }
        protected getIdProperty() { return PartyBalanceRow.idProperty; }
        protected getLocalTextPrefix() { return PartyBalanceRow.localTextPrefix; }
        protected getNameProperty() { return PartyBalanceRow.nameProperty; }
        protected getService() { return PartyBalanceService.baseUrl; }
        protected getDeletePermission() { return PartyBalanceRow.deletePermission; }
        protected getInsertPermission() { return PartyBalanceRow.insertPermission; }
        protected getUpdatePermission() { return PartyBalanceRow.updatePermission; }

        protected form = new PartyBalanceForm(this.idPrefix);

    }
}